import React from 'react'
import { Grid, Table, TableBody } from '@material-ui/core'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import styles from '@src/routes/Configurators/utils/styles'

interface OligoNameWarningProps {
  warning: any
}
const OligoNameWarning: React.FC<OligoNameWarningProps> = ({ warning }) => {
  const GlobalCSS = styles()
  return (
    <>
      <Grid className={GlobalCSS.validationWarningBorder}>
        <Table>
          <TableBody className={GlobalCSS.tableBorder}>
            <tr>
              <td className={GlobalCSS.validationWarningsTitle}>
                <WarningRoundedIcon
                  color="primary"
                  className={GlobalCSS.warningIcon}
                />
              </td>
              <td className={GlobalCSS.validationWarningsMessage}>{warning}</td>
            </tr>
          </TableBody>
        </Table>
      </Grid>
    </>
  )
}

export default OligoNameWarning
